<template lang="pug">
  .floors
    .floors__left
      swiper.floors__thumbs(
        :options="thumbsOptions"
        ref="swiperThumbs"
        @slide-change='thumbsChange()'
      )
        swiper-slide.floors__thumb(
          v-for="(item, index) in floors"
        )
          .floors__thumb-title {{ item.title }}

    .floors__right
      swiper.floors__slider(
        :options="sliderOptions"
        ref="swiperMain"
        @slide-change='sliderChange()'
      )
        swiper-slide.floors__slide(
          v-for="(item, index) in floors"
        )
          img(:src='item.picture')
            
      .floors__control
        button.floors__arrow.floors__arrow_prev(slot="button-prev")
          ArrowIcon
        .floors__navigation 
          .swiper-pagination(slot="pagination")
        button.floors__arrow.floors__arrow_next(slot="button-next")
          ArrowIcon
    .floors__compas(:style="`transform: rotate(${azimuth}deg)`")
      NordIcon.nord-arrow
</template>

<script>
import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import ArrowIcon from './arrow.svg';
import NordIcon from './nord-arrow.svg';

Vue.use(VueAwesomeSwiper);
export default {
  name: 'PageFloors',
  components: {
    ArrowIcon,
    NordIcon,
  },
  data: () => ({
    azimuth: 0,
    sliderOptions: {
      direction: 'vertical',
      spaceBetween: 0,
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      mousewheel: true,
      clickable: true,
      //loop: true,
      speed: 1000,
      centeredSlidesBounds: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.floors__arrow_next',
        prevEl: '.floors__arrow_prev',
      },
      breakpoints: {
        1024: {
          direction: 'horizontal',
        },
      },
    },
    thumbsOptions: {
      slidesPerView: 5,
      clickable: true,
      freemode: true,
      speed: 700,
      //loop: true,
      mousewheel: true,
      scrollWheel: true,
      effect: 'coverflow',
      spaceBetween: 120,
      centeredSlides: true,
      direction: 'vertical',
      centeredSlidesBounds: true,
      coverflowEffect: {
        rotate: 0,
        stretch: -100,
        depth: 300,
        modifier: 0.7,
        slideShadows: false,
      },
      breakpoints: {
        1200: {
          spaceBetween: 20,
          coverflowEffect: {
            rotate: 0,
            stretch: -50,
            depth: 50,
            modifier: 0.6,
            slideShadows: false,
          },
        },
        900: {
          direction: 'row',
          effect: 'default'
        }
      },
    },
    floors: [
      {
        title: '4',
        picture: require('./items/4.webp'),
        azimuth: 36,
      },
      {
        title: '6',
        picture: require('./items/6.webp'),
        azimuth: 12,
      },
      {
        title: '14',
        picture: require('./items/14.webp'),
        azimuth: 45,
      },
      {
        title: '15',
        picture: require('./items/15.webp'),
        azimuth: 76,
      },
      {
        title: '23',
        picture: require('./items/23.webp'),
        azimuth: 23,
      },
      {
        title: '24',
        picture: require('./items/24.webp'),
        azimuth: 41,
      },
      {
        title: '42',
        picture: require('./items/42.webp'),
        azimuth: 76,
      },
    ],
  }),
  methods: {
    showPage() {
      this.$el.classList.add('active');
    },
    clearCursor() {
      document.querySelector('.circle-cursor--outer').remove();
      document.querySelector('.circle-cursor--inner').remove();
    },
    thumbsChange() {
      const index = this.$refs.swiperThumbs.swiper.activeIndex;
      this.$refs.swiperMain.swiper.slideTo(index);
      this.azimuthChange(index);
    },
    sliderChange() {
      const index = this.$refs.swiperMain.swiper.activeIndex;
      this.$refs.swiperThumbs.swiper.slideTo(index);
      this.azimuthChange(index);
    },
    azimuthChange(index) {
      this.azimuth = this.floors[index].azimuth;
    },
  },

  mounted() {
    this.showPage();
  },
  beforeDestroy() {
    this.clearCursor();
  },
};
</script>

<style lang="sass">
@import "src/sass/general/medias"
@import "src/sass/general/variables"
@import "src/sass/general/text"

.floors
  display: grid
  height: 100vh
  margin-left: 73px
  grid-template-columns: 300px 1fr
  @media (max-width: $m-desktop)
    grid-template-columns: 140px 1fr
  @media (max-width: $b-tablet)
    grid-template-columns: initial
    margin-left: 0
    overflow: hidden

.floors__slider
  @media (max-width: $b-tablet)
    height: 100%
    width: 100vw
  .swiper-wrapper
    @media (max-width: $sm-desktop)
      flex-direction: row

.floors__left, .floors__right
  height: inherit

.floors__right
  display: grid
  grid-template-columns: 1fr 79px
  padding-right: $view-indent
  @media (max-width: $b-tablet)
    padding-right: $view-indent-mobile

.floors__left
  border-right: 1px solid $beige
  @media (max-width: $b-tablet)
    display: none
    height: 90px
    width: 100vw
    position: fixed
    bottom: 90px
    left: 0
    z-index: 2

.floors__slide
  height: 100vh
  display: flex
  justify-content: center
  align-items: center
  background: $light
  img
    mix-blend-mode: multiply
    @media (max-height: 900px) and (min-width: 1300px)
      width: 55% !important
    @media (max-height: 768px) and (min-width: 1530px)
      width: 45% !important
    @media (max-height: 768px) and (max-width: 1300px)
      width: 45% !important
    @media (max-height: 900px)
      width: 60%
    @media (max-width: $m-desktop)
      width: 60%
    @media (max-width: $b-tablet)
      width: 45%
    @media (max-width: $s-tablet)
      width: 60%
    @media (max-width: $xs-tablet)
      width: 80%
    @media (max-width: $b-mobile)
      width: 80% !important
    
    

.floors__thumbs
  height: inherit
  .swiper-wrapper
    @media (max-width: $sm-desktop)
      flex-direction: row
    @media (max-width: $b-tablet)
      display: none

.floors__thumb
  &.swiper-slide-active
    .floors__thumb-title
      opacity: 1
  &.swiper-slide-prev, &.swiper-slide-next
    .floors__thumb-title
      opacity: .6
  @media (max-width: $b-tablet)
    width: initial

.floors__thumb-title
  text-align: center
  display: flex
  line-height: 50%
  justify-content: center
  align-items: center
  +yo('font-size', ($l-desktop: 200px, $b-tablet: 64px))
  font-family: 'Baza'
  transition-duration: .7s
  opacity: .2

.floors__control
  height: 100%
  z-index: 1
  border-left: 1px solid $beige
  display: grid
  grid-template-rows: 1fr 72px 1fr
  padding: $view-indent 0
  @media (max-width: $b-tablet)
    padding: 0
    height: 90px
    width: 100vw
    position: fixed
    bottom: 0
    left: 0
    grid-template-rows: initial
    grid-template-columns: 1fr 72px 1fr
    border-top: 1px solid $beige
    border-bottom: 1px solid $beige

.floors__arrow
  border: none
  transition-duration: .4s
  background-color: transparent
  &:hover
    background-color: $beige
  &.swiper-button-disabled
    opacity: .5
    pointer-events: none

.floors__navigation
  border-top: 1px solid $beige
  border-bottom: 1px solid $beige
  position: relative
  @media (max-width: $b-tablet)
    border-top: none
    border-bottom: none
    border-right: 1px solid $beige
    border-left: 1px solid $beige
  .swiper-pagination
    z-index: 0
    display: flex
    justify-content: center
    text-align: center
    align-items: center
    grid-gap: 4px
    position: initial
    height: 100%

  .swiper-pagination-current, .swiper-pagination-total
    color: black
    opacity: 1
    font-size: 11px
    font-weight: 300
    font-family: 'Futura Light'
    &:after, &:before
      display: none

.floors__arrow_next
  svg
    transform: rotate(90deg)
    @media (max-width: $b-tablet)
      transform: rotate(0deg) scale(.6)

.floors__arrow_prev
  svg
    transform: rotate(-90deg)
    @media (max-width: $b-tablet)
      transform: rotate(-180deg) scaleY(-1) scale(.6)

.floors__compas
  position: absolute
  background: $light
  border: 1px solid $beige
  border-radius: 100%
  width: 80px
  transition-duration: .6s
  height: 80px
  transform: translateX(9em)
  top: 4em
  transition-delay: 0s
  right: 9em
  z-index: 1
  @media (max-width: $b-tablet)
    width: 40px
    height: 40px
    top: 95px
    left: 25px
  .nord-arrow
    +center
    transition-duration: .6s
    transition-timing-function: cubic-bezier(.77,0,.175,1)
    transition-delay: .2s
    position: absolute
    @media (max-width: $b-tablet)
      transform: scale(.6)
</style>
